var map = {
	"./business.signup.ts": 98341,
	"./calendar.signup.ts": 11633,
	"./drive.signup.ts": 96391,
	"./lumo.signup.ts": 15550,
	"./mail.signup.ts": 59190,
	"./partner.porkbun.signup.ts": 40958,
	"./pass.signup.ts": 89796,
	"./refer-a-friend.signup.ts": 43778,
	"./signup.ts": 34121,
	"./vpn.signup.ts": 34143,
	"./wallet.signup.ts": 61072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90169;